// @flow
import api from 'tim-api';
import {
  rechargeBase as rechargeBaseEndPoint,
  chipBase as chipBaseEndPoint,
  capillarityBase as capillarityBaseEndPoint,
  beepBase as beepBaseEndPoint,
  exportDuplicateBase as duplicateBaseEndpoint,
  importHistoryBase as importHistoryBaseEndPoint
} from 'endPoints';

export const state = {
  rechargeBase: [],
  chipBases: [],
  capillarityBase: [],
  beepBase: [],
  exportDuplicateBase: [],
  importHistoryBase: []
};

export const getters = {
  rechargeBase: (state: Object) => state.rechargeBase,
  chipBases: (state: Object) => state.chipBases,
  capillarityBase: (state: Object) => state.capillarityBase,
  beepBase: (state: Object) => state.beepBase,
  exportDuplicateBase: (state: Object) => state.exportDuplicateBase,
  importHistoryBase: (state: Object) => state.importHistoryBase
};

export const mutations = {
  SET_RECHARGE_BASE(state: Object, rechargeBase: Array<Object>) {
    state.rechargeBase = rechargeBase;
  },
  SET_CHIP_BASE(state: Object, chipBases: Array<Object>) {
    state.chipBases = chipBases;
  },
  SET_CAPILLARITY_BASE(state: Object, capillarityBase: Array<Object>) {
    state.capillarityBase = capillarityBase;
  },
  SET_BEEP_BASE(state: Object, beepBase: Array<Object>) {
    state.beepBase = beepBase;
  },
  SET_DUPLICATEACTIVATION_BASE(state: Object, exportDuplicateBase: Array<Object>) {
    state.exportDuplicateBase = exportDuplicateBase;
  },
  SET_IMPORT_HISTORY(state: Object, importHistoryBase: Array<Object>) {
    state.importHistoryBase = importHistoryBase;
  }
};

export const actions = {
  fetchRechargeBase({ commit }: Action, filter: Object) {
    commit('SET_RECHARGE_BASE', []);

    const url = `${rechargeBaseEndPoint}`;
    return api.post(url, filter, {
      responseType: 'blob'
    });
  },
  fetchChipBase({ commit }: Action, filter: Object) {
    commit('SET_CHIP_BASE', []);

    const url = `${chipBaseEndPoint}`;
    return api.post(url, filter, {
      responseType: 'blob'
    });
  },
  fetchCapillarityBase({ commit }: Action, filter: Object) {
    commit('SET_CAPILLARITY_BASE', []);

    const url = `${capillarityBaseEndPoint}`;
    return api.post(url, filter, {
      responseType: 'blob'
    });
  },
  fetchBeepBase({ commit }: Action, filter: Object) {
    commit('SET_BEEP_BASE', []);

    const url = `${beepBaseEndPoint}`;
    return api.post(url, filter, {
      responseType: 'blob'
    });
  },
  fetchDuplicateActivationBase({ commit }: Action, filter: Object) {
    commit('SET_DUPLICATEACTIVATION_BASE', []);

    const url = `${duplicateBaseEndpoint}`;
    return api.post(url, filter, {
      responseType: 'blob'
    });
  },
  fetchImportHistoryBase({ commit }: Action, filter: Object) {
    commit('SET_IMPORT_HISTORY', []);

    const url = `${importHistoryBaseEndPoint}`;
    return api.post(url, filter, {
      responseType: 'blob'
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
